import { Component, ViewChild, ChangeDetectionStrategy, ElementRef } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { ICellEditorParams } from 'ag-grid-community';
import { GuiUtils } from "src/modules/utils/misc/gui-utils";
import { FrontendField } from '../../netgen/FrontendField';
import { FrontendForm } from '../../netgen/FrontendForm';
import { SmFormComponent } from '../sm-form/sm-form.component';
import { FrontendFieldType } from '../../netgen/FrontendFieldType';
import { Arrays } from 'src/modules/utils/shared/arrays';
import { Objects } from "src/modules/utils/shared/objects";

@Component({
    selector: 'sm-table-cell-editor',
    templateUrl: './sm-table-cell-editor.component.html',
    styleUrl: './sm-table-cell-editor.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SmTableCellEditorComponent implements ICellEditorAngularComp {

  form: FrontendForm;
  
  @ViewChild("formComponent")
  formComponent: SmFormComponent;
  
  params: ICellEditorParams;
  isTableEditorPopup = false;
  stopEditingRequested = false;

  constructor(private elementRef: ElementRef<HTMLElement>) {
  }

  agInit(params: ICellEditorParams): void {
    this.params = params;
    this.form = new FrontendForm([(params as any).editor as FrontendField]);
    this.form.fields[0].hasLabel = false;
    let type = this.form.fields[0].type;
    let continuousInputTypes = [FrontendFieldType.table, FrontendFieldType.string, FrontendFieldType.int, FrontendFieldType.decimal, FrontendFieldType.date, FrontendFieldType.dateTime];
    if (!continuousInputTypes.includes(type) && !(type == FrontendFieldType.dropdown && this.form.fields[0].dropdownEditable)) {
        this.form.fields[0].onValueChanged = () => {
            this.ensureChangedValue();
            if (!this.stopEditingRequested) {
                this.stopEditingRequested = true;
                GuiUtils.angularTimer(() => this.params.stopEditing());
            }
        };
    }
    this.form.fields[0].tableCellEditor = this;
    this.form.fields[0].value = this.form.fields[0].userDefinedData?.cloneValueForTableCellEditor ? Objects.cloneDeep(params.value) : params.value;
    this.form.fields[0].focus();
    this.isTableEditorPopup = this.form.fields[0].type == FrontendFieldType.table && params.colDef.cellEditorPopup;
  }

  afterGuiAttached(): void {
    this.formComponent?.thisComponentAsTableEditorInited();
    // Beim Start des Editors ist der Datepicker noch nicht gerendert und AG Grid fokussiert anschließend die Zelle; das Eingabefeld erhält den Fokus daher erst hier
    let type = this.form.fields[0].type;
    if (type == FrontendFieldType.date || type == FrontendFieldType.dateTime) {
      GuiUtils.angularTimer(() => {
        // Tab soll zur nächsten Zelle wechseln und nicht auf dem Kalenderknopf landen; per Maus bleibt er nutzbar
        this.elementRef.nativeElement.querySelector(".p-datepicker-dropdown")?.setAttribute("tabindex", "-1");
        let input = this.elementRef.nativeElement.querySelector("input");
        input?.focus();
        input?.setSelectionRange(0, 0);
      });
    }
  }

  getValue(): any {
    return this.form.fields[0].getValue();
  }

  handleKeyboardEvent(e: KeyboardEvent): void {
    if (e.key == "Tab") {
        e.preventDefault();
        if (e.shiftKey) {
            this.params.api.tabToPreviousCell();
        } 
        else {
            this.params.api.tabToNextCell();
        }
    }
  }

  toNextCell(): void {
        //   Utils.setTimerOnce(100, () =>
        //     this.params.api.startEditingCell({ rowIndex: this.params.rowIndex, colKey: this.params.colDef.colId }));
  }

  close(): void {
    this.ensureChangedValue();
    this.params.stopEditing();
    // Der Fokus bleibt auf der Zelle, damit Tab und Enter danach weiter in der Tabelle wirken
    this.params.api.setFocusedCell(this.params.node.rowIndex, this.params.column);
  }

  ensureChangedValue(): void {
    //Andernfalls wird keine Änderung erkannt und valueSetter nicht aufgerufen, wenn der gleiche Wert eingegeben wird wie vorher.
        //Das liegt wahrscheinlich daran, dass die Tabelle denkt, dass sich der Wert nicht geändert hat und deshalb den valueSetter nicht aufruft.
        //Durch das Setzen eines neuen Arrays wird die Änderung erkannt, auch wenn der Inhalt gleich ist.
    //Projektplanung Gliederungsvorlagentabelle Feld Rollen
    if (Arrays.is(this.form.fields[0].value)) {
        this.form.fields[0].value = [...this.form.fields[0].value];
    }    
  }

}
